import { api } from '../api'
import { DonateResponse, DonateRequestBody } from 'models/ChargeIntent'

export const donateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    donate: builder.mutation<
      DonateResponse,
      { campaignId: string; paymentMethod: string; body: DonateRequestBody }
    >({
      query: ({ campaignId, paymentMethod, body }) => ({
        url: `/donate?campaign_id=${campaignId}&payment_method=${paymentMethod}`,
        method: 'POST',
        body: body,
      }),
    }),
    recurring: builder.mutation<
      DonateResponse,
      { campaignId: string; paymentMethod: string; body: DonateRequestBody }
    >({
      query: ({ campaignId, paymentMethod, body }) => ({
        url: `/donate?campaign_id=${campaignId}&recurring=true&payment_method=${paymentMethod}`,
        method: 'POST',
        body: body,
      }),
    }),
  }),
})

/**
 * Export the query hooks as well as the endpoints (for SSR).
 */
export const {
  endpoints: { donate, recurring },
  useDonateMutation,
  useRecurringMutation,
} = donateApi
